module.exports = __webpack_public_path__ + "images/category_lp/pc/lppc-Hikaku_KaitoriCase1_4f9723215d7582a8a11b8237af3fba1c.png";